// export let UsersModalLayoutJSON = [
//   {
//     name: "Details",
//     child: [
//       {
//         child: [
//           {
//             child: [
//               {
//                 parentid: "1691038369077-col-1",
//                 elementid: "1691128809696",
//                 elementtype: "textfield",
//               },
//               {
//                 parentid: "1691038369077-col-1",
//                 elementid: "1691129840826",
//                 elementtype: "textfield",
//               },
//               {
//                 parentid: "1691038369077-col-1",
//                 elementid: "1691129872952",
//                 elementtype: "customSelect",
//               },
//             ],
//             colpos: 1,
//             parentid: "1691038369077-columns",
//             elementid: "1691038369077-col-1",
//             elementtype: "column",
//             colsizeclass: "col-md-6",
//           },
//           {
//             child: [
//               {
//                 parentid: "1691038369077-col-2",
//                 elementid: "1691129682425",
//                 elementtype: "textfield",
//               },
//               {
//                 parentid: "1691038369077-col-2",
//                 elementid: "1691129861338",
//                 elementtype: "phoneNumber",
//               },
//               {
//                 parentid: "1691038369077-col-2",
//                 elementid: "1691129875702",
//                 elementtype: "customSelect",
//               },
//             ],
//             colpos: 2,
//             parentid: "1691038369077-columns",
//             elementid: "1691038369077-col-2",
//             elementtype: "column",
//             colsizeclass: "col-md-6",
//           },
//         ],
//         colsize: 2,
//         parentid: "section-1691038345911-form",
//         elementid: "1691038369077",
//         elementtype: "columns",
//       },
//     ],
//     parentid: "myTabContent",
//     elementid: "section-1691038345911",
//     description: "",
//     elementtype: "section",
//     "section-type": "form",
//     linkedentitytype: -1,
//   },
//   {
//     name: "New",
//     child: [
//       // {
//       //   child: [
//       //     {
//       //       child: [
//       //         {
//       //           parentid: "1691038369077-col-1",
//       //           elementid: "1691128809696",
//       //           elementtype: "textfield",
//       //         },
//       //         {
//       //           parentid: "1691038369077-col-1",
//       //           elementid: "1691129840826",
//       //           elementtype: "textfield",
//       //         },
//       //         {
//       //           parentid: "1691038369077-col-1",
//       //           elementid: "1691129872952",
//       //           elementtype: "customSelect",
//       //         },
//       //       ],
//       //       colpos: 1,
//       //       parentid: "1691038369077-columns",
//       //       elementid: "1691038369077-col-1",
//       //       elementtype: "column",
//       //       colsizeclass: "col-md-6",
//       //     },
//       //     {
//       //       child: [
//       //         {
//       //           parentid: "1691038369077-col-2",
//       //           elementid: "1691129682425",
//       //           elementtype: "textfield",
//       //         },
//       //         {
//       //           parentid: "1691038369077-col-2",
//       //           elementid: "1691129861338",
//       //           elementtype: "phoneNumber",
//       //         },
//       //         {
//       //           parentid: "1691038369077-col-2",
//       //           elementid: "1691129875702",
//       //           elementtype: "customSelect",
//       //         },
//       //       ],
//       //       colpos: 2,
//       //       parentid: "1691038369077-columns",
//       //       elementid: "1691038369077-col-2",
//       //       elementtype: "column",
//       //       colsizeclass: "col-md-6",
//       //     },
//       //   ],
//       //   colsize: 2,
//       //   parentid: "section-1691038345911-form",
//       //   elementid: "1691038369077",
//       //   elementtype: "columns",
//       // },
//     ],
//     parentid: "myTabContent",
//     elementid: "section-1691038345911",
//     description: "",
//     elementtype: "section",
//     "section-type": "form",
//     linkedentitytype: -1,
//   },
// ];

export let FormLayoutJSON = [
  {
    name: "Member Details",
    child: [
      {
        child: [
          {
            child: [
              {
                parentid: "1626228887540-col-1",
                elementid: "1623583428562",
                elementtype: "textfield",
              },
            ],
            colpos: 1,
            parentid: "1626228887540-columns",
            elementid: "1626228887540-col-1",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
          {
            child: [
              {
                parentid: "1626228887540-col-2",
                elementid: "1623583531428",
                elementtype: "customSelect",
              },
            ],
            colpos: 2,
            parentid: "1626228887540-columns",
            elementid: "1626228887540-col-2",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
        ],
        colsize: 2,
        parentid: "section-1623582482045-form",
        elementid: "1626228887540",
        elementtype: "columns",
      },
      {
        child: [
          {
            child: [
              {
                parentid: "1626228961905-col-1",
                elementid: "1623583672842",
                elementtype: "textfield",
              },
            ],
            colpos: 1,
            parentid: "1626228961905-columns",
            elementid: "1626228961905-col-1",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
          {
            child: [
              {
                parentid: "1626228961905-col-2",
                elementid: "1623583704764",
                elementtype: "date",
              },
            ],
            colpos: 2,
            parentid: "1626228961905-columns",
            elementid: "1626228961905-col-2",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
        ],
        colsize: 2,
        parentid: "section-1623582482045-form",
        elementid: "1626228961905",
        elementtype: "columns",
      },
      {
        child: [
          {
            child: [
              {
                parentid: "1626229083325-col-1",
                elementid: "1623584097938",
                elementtype: "phoneNumber",
              },
            ],
            colpos: 1,
            parentid: "1626229083325-columns",
            elementid: "1626229083325-col-1",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
          {
            child: [
              {
                parentid: "1626229083325-col-2",
                elementid: "1623584089894",
                elementtype: "email",
              },
            ],
            colpos: 2,
            parentid: "1626229083325-columns",
            elementid: "1626229083325-col-2",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
        ],
        colsize: 2,
        parentid: "section-1623582482045-form",
        elementid: "1626229083325",
        elementtype: "columns",
      },
      {
        child: [
          {
            child: [
              {
                parentid: "1624124535431-col-1",
                elementid: "1623583767263",
                elementtype: "customSelect",
              },
            ],
            colpos: 1,
            parentid: "1624124535431-columns",
            elementid: "1624124535431-col-1",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
          {
            child: [
              {
                parentid: "1624124535431-col-2",
                elementid: "1626229196753",
                elementtype: "number",
              },
            ],
            colpos: 2,
            parentid: "1624124535431-columns",
            elementid: "1624124535431-col-2",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
        ],
        colsize: 2,
        parentid: "section-1623582482045-form",
        elementid: "1624124535431",
        elementtype: "columns",
      },
      {
        child: [
          {
            child: [
              {
                parentid: "1624875837103-col-1",
                elementid: "1626229349639",
                elementtype: "customSelect",
              },
              {
                parentid: "1624875837103-col-1",
                elementid: "1626229354113",
                elementtype: "customSelect",
              },
            ],
            colpos: 1,
            parentid: "1624875837103-columns",
            elementid: "1624875837103-col-1",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
          {
            child: [
              {
                parentid: "1624875837103-col-2",
                elementid: "1623584055792",
                elementtype: "textarea",
              },
            ],
            colpos: 2,
            parentid: "1624875837103-columns",
            elementid: "1624875837103-col-2",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
        ],
        colsize: 2,
        parentid: "section-1623582482045-form",
        elementid: "1624875837103",
        elementtype: "columns",
      },
      {
        child: [
          {
            child: [
              {
                parentid: "1624875681139-col-1",
                elementid: "1624875844928",
                elementtype: "textfield",
              },
              {
                parentid: "1624875681139-col-1",
                elementid: "1676018317533",
                elementtype: "textfield",
              },
              {
                parentid: "1624875681139-col-1",
                elementid: "1676018327664",
                elementtype: "textfield",
              },
            ],
            colpos: 1,
            parentid: "1624875681139-columns",
            elementid: "1624875681139-col-1",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
          {
            child: [
              {
                parentid: "1624875681139-col-2",
                elementid: "1624875734793",
                elementtype: "customSelect",
              },
              {
                parentid: "1624875681139-col-2",
                elementid: "1624875746381",
                elementtype: "textarea",
              },
            ],
            colpos: 2,
            parentid: "1624875681139-columns",
            elementid: "1624875681139-col-2",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
        ],
        colsize: 2,
        parentid: "section-1623582482045-form",
        elementid: "1624875681139",
        elementtype: "columns",
      },
    ],
    parentid: "myTabContent",
    elementid: "section-1623582482045",
    description: "",
    elementtype: "section",
    "section-type": "form",
    linkedentitytype: -1,
  },
  {
    name: "Hospital Details",
    child: [
      {
        child: [
          {
            child: [
              {
                parentid: "1624877097862-col-1",
                elementid: "1624877155661",
                elementtype: "textfield",
              },
              {
                parentid: "1624877097862-col-1",
                elementid: "1624878310627",
                elementtype: "textfield",
              },
            ],
            colpos: 1,
            parentid: "1624877097862-columns",
            elementid: "1624877097862-col-1",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
          {
            child: [
              {
                parentid: "1624877097862-col-2",
                elementid: "1624877173953",
                elementtype: "textfield",
              },
              {
                parentid: "1624877097862-col-2",
                elementid: "1628243161423",
                elementtype: "customSelect",
              },
            ],
            colpos: 2,
            parentid: "1624877097862-columns",
            elementid: "1624877097862-col-2",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
        ],
        colsize: 2,
        parentid: "section-1624876607950-form",
        elementid: "1624877097862",
        elementtype: "columns",
      },
      {
        child: [
          {
            child: [
              {
                parentid: "1624877121197-col-1",
                elementid: "1624877179896",
                elementtype: "textarea",
              },
              {
                parentid: "1624877121197-col-1",
                elementid: "1624877191523",
                elementtype: "email",
              },
              {
                parentid: "1624877121197-col-1",
                elementid: "1624877195323",
                elementtype: "phoneNumber",
              },
            ],
            colpos: 1,
            parentid: "1624877121197-columns",
            elementid: "1624877121197-col-1",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
          {
            child: [
              {
                parentid: "1624877121197-col-2",
                elementid: "1626230087036",
                elementtype: "number",
              },
              {
                parentid: "1624877121197-col-2",
                elementid: "1626230016540",
                elementtype: "customSelect",
              },
              {
                parentid: "1624877121197-col-2",
                elementid: "1626230010543",
                elementtype: "customSelect",
              },
            ],
            colpos: 2,
            parentid: "1624877121197-columns",
            elementid: "1624877121197-col-2",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
        ],
        colsize: 2,
        parentid: "section-1624876607950-form",
        elementid: "1624877121197",
        elementtype: "columns",
      },
      {
        child: [
          {
            child: [
              {
                parentid: "1624877135609-col-1",
                elementid: "1624880057791",
                elementtype: "customSelect",
              },
              {
                parentid: "1624877135609-col-1",
                elementid: "1624877632695",
                elementtype: "textarea",
              },
            ],
            colpos: 1,
            parentid: "1624877135609-columns",
            elementid: "1624877135609-col-1",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
          {
            child: [
              {
                parentid: "1624877135609-col-2",
                elementid: "1624877993136",
                elementtype: "customSelect",
              },
              {
                parentid: "1624877135609-col-2",
                elementid: "1624877997138",
                elementtype: "textarea",
              },
            ],
            colpos: 2,
            parentid: "1624877135609-columns",
            elementid: "1624877135609-col-2",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
        ],
        colsize: 2,
        parentid: "section-1624876607950-form",
        elementid: "1624877135609",
        elementtype: "columns",
      },
      {
        child: [
          {
            child: [
              {
                parentid: "1629472959220-col-1",
                elementid: "1624878091841",
                elementtype: "multiselect",
              },
              {
                parentid: "1629472959220-col-1",
                elementid: "1628243908637",
                elementtype: "textfield",
              },
            ],
            colpos: 1,
            parentid: "1629472959220-columns",
            elementid: "1629472959220-col-1",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
          {
            child: [
              {
                parentid: "1629472959220-col-2",
                elementid: "1628243579331",
                elementtype: "number",
              },
              {
                parentid: "1629472959220-col-2",
                elementid: "1628243723750",
                elementtype: "number",
              },
            ],
            colpos: 2,
            parentid: "1629472959220-columns",
            elementid: "1629472959220-col-2",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
        ],
        colsize: 2,
        parentid: "section-1624876607950-form",
        elementid: "1629472959220",
        elementtype: "columns",
      },
      {
        child: [
          {
            child: [
              {
                parentid: "1629473542704-col-1",
                elementid: "1628244239948",
                elementtype: "customSelect",
              },
              {
                parentid: "1629473542704-col-1",
                elementid: "1628244478099",
                elementtype: "customSelect",
              },
            ],
            colpos: 1,
            parentid: "1629473542704-columns",
            elementid: "1629473542704-col-1",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
          {
            child: [],
            colpos: 2,
            parentid: "1629473542704-columns",
            elementid: "1629473542704-col-2",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
        ],
        colsize: 2,
        parentid: "section-1624876607950-form",
        elementid: "1629473542704",
        elementtype: "columns",
      },
    ],
    parentid: "myTabContent",
    elementid: "section-1624876607950",
    description: "",
    elementtype: "section",
    "section-type": "form",
    linkedentitytype: -1,
  },
  {
    name: "Staff Details",
    child: [
      {
        child: [
          {
            child: [
              {
                parentid: "1624878723180-col-1",
                elementid: "1629533603970",
                elementtype: "number",
              },
            ],
            colpos: 1,
            parentid: "1624878723180-columns",
            elementid: "1624878723180-col-1",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
          {
            child: [
              {
                parentid: "1624878723180-col-2",
                elementid: "1624878772495",
                elementtype: "textarea",
              },
            ],
            colpos: 2,
            parentid: "1624878723180-columns",
            elementid: "1624878723180-col-2",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
        ],
        colsize: 2,
        parentid: "section-1624878435192-form",
        elementid: "1624878723180",
        elementtype: "columns",
      },
      {
        child: [
          {
            child: [
              {
                parentid: "1624878726743-col-1",
                elementid: "1624878779939",
                elementtype: "customSelect",
              },
              {
                parentid: "1624878726743-col-1",
                elementid: "1624878790786",
                elementtype: "textarea",
              },
            ],
            colpos: 1,
            parentid: "1624878726743-columns",
            elementid: "1624878726743-col-1",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
          {
            child: [
              {
                parentid: "1624878726743-col-2",
                elementid: "1624878794409",
                elementtype: "customSelect",
              },
              {
                parentid: "1624878726743-col-2",
                elementid: "1624878798751",
                elementtype: "textarea",
              },
            ],
            colpos: 2,
            parentid: "1624878726743-columns",
            elementid: "1624878726743-col-2",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
        ],
        colsize: 2,
        parentid: "section-1624878435192-form",
        elementid: "1624878726743",
        elementtype: "columns",
      },
      {
        child: [
          {
            child: [
              {
                parentid: "1624878735291-col-1",
                elementid: "1624878825449",
                elementtype: "customSelect",
              },
              {
                parentid: "1624878735291-col-1",
                elementid: "1624878829492",
                elementtype: "textarea",
              },
            ],
            colpos: 1,
            parentid: "1624878735291-columns",
            elementid: "1624878735291-col-1",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
          {
            child: [
              {
                parentid: "1624878735291-col-2",
                elementid: "1624878814120",
                elementtype: "customSelect",
              },
              {
                parentid: "1624878735291-col-2",
                elementid: "1624878818463",
                elementtype: "textarea",
              },
            ],
            colpos: 2,
            parentid: "1624878735291-columns",
            elementid: "1624878735291-col-2",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
        ],
        colsize: 2,
        parentid: "section-1624878435192-form",
        elementid: "1624878735291",
        elementtype: "columns",
      },
      {
        child: [
          {
            child: [
              {
                parentid: "1624878742994-col-1",
                elementid: "1624878846361",
                elementtype: "textarea",
              },
            ],
            colpos: 1,
            parentid: "1624878742994-columns",
            elementid: "1624878742994-col-1",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
          {
            child: [],
            colpos: 2,
            parentid: "1624878742994-columns",
            elementid: "1624878742994-col-2",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
        ],
        colsize: 2,
        parentid: "section-1624878435192-form",
        elementid: "1624878742994",
        elementtype: "columns",
      },
    ],
    parentid: "myTabContent",
    elementid: "section-1624878435192",
    description: "",
    elementtype: "section",
    "section-type": "form",
    linkedentitytype: -1,
  },
  {
    name: "Patient Count and Claims Details",
    child: [
      {
        child: [
          {
            parentid: "1629534249341-fieldset-body",
            elementid: "1624879762473",
            elementtype: "customSelect",
          },
          {
            parentid: "1629534249341-fieldset-body",
            elementid: "1624879776143",
            elementtype: "number",
          },
          {
            parentid: "1629534249341-fieldset-body",
            elementid: "1624879779425",
            elementtype: "number",
          },
        ],
        parentid: "section-1624879693430-form",
        elementid: "1629534249341",
        elementtype: "fieldset",
      },
      {
        child: [
          {
            parentid: "1629534294968-fieldset-body",
            elementid: "1629534403064",
            elementtype: "textarea",
          },
          {
            parentid: "1629534294968-fieldset-body",
            elementid: "1629534478996",
            elementtype: "textarea",
          },
          {
            parentid: "1629534294968-fieldset-body",
            elementid: "1629534566853",
            elementtype: "customSelect",
          },
        ],
        parentid: "section-1624879693430-form",
        elementid: "1629534294968",
        elementtype: "fieldset",
      },
    ],
    parentid: "myTabContent",
    elementid: "section-1624879693430",
    description: "",
    elementtype: "section",
    "section-type": "form",
    linkedentitytype: -1,
  },
  {
    name: "Upload Document",
    child: [
      {
        parentid: "section-1623585786319-form",
        elementid: "1623586686657",
        elementtype: "documentFile",
      },
      {
        parentid: "section-1623585786319-form",
        elementid: "1690628833821",
        elementtype: "date",
      },
      {
        parentid: "section-1623585786319-form",
        elementid: "1623586772951",
        elementtype: "documentFile",
      },
      {
        parentid: "section-1623585786319-form",
        elementid: "1690629202935",
        elementtype: "documentFile",
      },
    ],
    parentid: "myTabContent",
    elementid: "section-1623585786319",
    description: "",
    elementtype: "section",
    "section-type": "form",
    linkedentitytype: -1,
  },
  {
    name: "Avail other offers",
    child: [
      {
        parentid: "section-1676350482384-form",
        elementid: "1676350495836",
        elementtype: "textfield",
      },
      {
        parentid: "section-1676350482384-form",
        elementid: "1676517861196",
        elementtype: "date",
      },
      {
        parentid: "section-1676350482384-form",
        elementid: "1676350513451",
        elementtype: "textfield",
      },
      {
        parentid: "section-1676350482384-form",
        elementid: "1676517877864",
        elementtype: "date",
      },
      {
        parentid: "section-1676350482384-form",
        elementid: "1676350522935",
        elementtype: "textfield",
      },
      {
        parentid: "section-1676350482384-form",
        elementid: "1676517886413",
        elementtype: "date",
      },
    ],
    parentid: "myTabContent",
    elementid: "section-1676350482384",
    description: "",
    elementtype: "section",
    "section-type": "form",
    linkedentitytype: -1,
  },
];

export let UsersModalLayoutJSON = [
  {
    name: "New",
    child: [
      {
        child: [
          {
            child: [
              {
                parentid: "1692362019775-col-1",
                elementid: "1692362079963",
                elementtype: "textfield",
              },
              {
                parentid: "1692362019775-col-2",
                elementid: "1692363740621",
                elementtype: "phoneNumber",
              },
              {
                parentid: "1692362019775-col-3",
                elementid: "1624878742994",
                elementtype: "customSelect",
              },
              // {
              //   parentid: "1692362019775-col-3",
              //   elementid: "1692362079960",
              //   elementtype: "textfield",
              // },

              // {
              //   parentid: "1623586686657-col-3",
              //   elementid: "1623586686657",
              //   elementtype: "password",
              // },
            ],
            colpos: 1,
            parentid: "1692362019775-columns",
            elementid: "1692362019775-col-1",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
          {
            child: [
              {
                parentid: "1692362019775-col-2",
                elementid: "1692362083195",
                elementtype: "email",
              },
              {
                parentid: "1692362019775-col-1",
                elementid: "1692363731639",
                elementtype: "customSelect",
              },
              {
                parentid: "1692362019775-col-1",
                elementid: "1718962116335",
                elementtype: "radio",
              },
            ],
            colpos: 2,
            parentid: "1692362019775-columns",
            elementid: "1692362019775-col-2",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
        ],
        colsize: 2,
        parentid: "section-1692362014074-form",
        elementid: "1692362019775",
        elementtype: "columns",
      },
    ],
    parentid: "myTabContent",
    elementid: "section-1692362014074",
    description: "",
    elementtype: "others",
    "section-type": "form",
    linkedentitytype: -1,
  },
];
